<template>
    <div class="oauth-callback">
        <div class="loading-container">
            <i class="el-icon-loading"></i>
            <span>{{ $d('正在处理登录，请稍候...') }}</span>
        </div>
    </div>
</template>

<script>
import {getUrlParam} from '@/utils/common'

export default {
    name: 'oauth-callback',
    mounted () {
        this.handleCallback()
    },
    methods: {
        handleCallback () {
            // 从 URL 中获取参数
            const code = getUrlParam('code')
            const state = getUrlParam('state')
            // const savedState = localStorage.getItem('oauth_state')

            if (!code || !state) {
                this.$message.error(this.$d('登录失败，请重试'))
                this.$router.push('/login')
                return
            }

            // 清除保存的 state
            localStorage.removeItem('oauth_state')

            // 获取租户信息
            const tenant = this.etao.common.getData('tenantInfo')
            if (!tenant) {
                this.$message.error(this.$d('未选择租户，请先选择租户'))
                this.$router.push('/login')
                return
            }

            // 发送 OAuth2 登录请求
            this.etao.requests.post({
                url: '/etao-auth/oauth/token',
                prototype: 'FormData',
                data: {
                    grant_type: 'authorization_code',
                    code: code,
                    redirect_uri: window.config.redirectUri,
                    client_id: 'etao',
                    tenant_id: tenant.tenantId
                },
                sendToken: false,
                successMessage: false,
                success: res => {
                    if (Object.keys(res).indexOf('success') >= 0 && !res.success) {
                        this.$message.error(res.error_description)
                        this.$router.push('/login')
                        return
                    }

                    // 保存用户信息
                    this.etao.common.saveData('userInfo', {
                        realName: res['real_name'],
                        loginName: res['account'],
                        userId: res['user_id']
                    })

                    // 保存租户信息
                    this.etao.common.saveData('tenantInfo', {
                        tenantId: tenant['tenantId'],
                        tenantName: tenant['tenantName'],
                        logoUrl: tenant['logoUrl']
                    })

                    // 保存 token
                    this.etao.common.setToken(res['access_token'])
                    this.etao.common.setToken(res['refresh_token'], 'r')

                    // 跳转到首页
                    this.$router.push('/index')
                },
                error: () => {
                    this.$message.error(this.$d('登录失败，请重试'))
                    this.$router.push('/login')
                }
            })
        }
    }
}
</script>

<style scoped>
.oauth-callback {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.loading-container i {
    font-size: 40px;
    color: #409EFF;
}

.loading-container span {
    font-size: 16px;
    color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/login/oauth-callback.vue